import { create } from 'zustand';
import { detectUserCountry, getRegionFromPath } from '@/services/countryService';

interface RegionState {
    // Store region: the region the user is currently browsing (based on URL path, e.g. 'gb' for /)
    storeRegion: string;
    // Detected region: the region the user's IP is from (from API)
    detectedRegion: string | null;
    // Chosen region: the region the user has selected (what they want to see/buy from)
    chosenRegion: string | null;
    // Legacy: urlRegion (will be deprecated)
    urlRegion: string | null;
    showRegionModal: boolean;
    acceptedRegion: string | null;
    isDetectingRegion: boolean;
    // Actions
    setStoreRegion: (region: string) => void;
    setChosenRegion: (region: string) => void;
    setDetectedRegion: (region: string) => void;
    setShowRegionModal: (show: boolean) => void;
    getUrlRegion: (path: string) => void;
    detectRegion: () => Promise<void>;
    setAcceptedRegion: (region: string | null) => void;
    setIsDetectingRegion: (isDetecting: boolean) => void;
}

const useRegionStore = create<RegionState>((set) => ({
    storeRegion: 'gb', // Default to GB for root path (/)
    detectedRegion: null,
    chosenRegion: 'gb', // Defaults to store region
    urlRegion: null,
    showRegionModal: false,
    acceptedRegion: null,
    isDetectingRegion: true,
    setStoreRegion: (region) => set({ storeRegion: region }),
    setChosenRegion: (region) => set({ chosenRegion: region }),
    setDetectedRegion: (region) => set({ detectedRegion: region }),
    setShowRegionModal: (show) => set({ showRegionModal: show }),
    getUrlRegion: (path) => set({ urlRegion: getRegionFromPath(path) }),
    setAcceptedRegion: (region) => set({ acceptedRegion: region }),
    setIsDetectingRegion: (isDetecting) => set({ isDetectingRegion: isDetecting }),
    detectRegion: async () => {
        set({ isDetectingRegion: true });
        try {
            const region = await detectUserCountry();
            set((state) => ({
                detectedRegion: region,
                chosenRegion: state.chosenRegion || region,
                isDetectingRegion: false
            }));
        } catch (error) {
            console.error('Failed to detect region:', error);
            set((state) => ({
                detectedRegion: 'gb',
                chosenRegion: state.chosenRegion || 'gb',
                isDetectingRegion: false
            }));
        }
    },
}));

export default useRegionStore; 
